import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  title = 'COMDICA';
  condition!: boolean;

  ngAfterViewInit(): void {
    this.condition = window.location.hash == "#/termos-politicas/termos-servicos" || 
                    window.location.hash === "#/termos-politicas/politica-privacidade" || 
                    window.location.href === "http://localhost:4200/#/termos-politicas"
    window.addEventListener('hashchange', () => {
      this.condition = window.location.hash == "#/termos-politicas/termos-servicos" || 
                      window.location.hash === "#/termos-politicas/politica-privacidade" ||
                      window.location.href === "http://localhost:4200/#/termos-politicas"

                    })

    const footer = document.querySelector('.footer');
      if (footer) {
       const footerHeight = footer.clientHeight;
        document.documentElement.style.setProperty('--footer-height', `${footerHeight}px`);
    }
  }
}
